module.exports = __webpack_public_path__ + "img/8_kim_n.3232e46c.png";